// Styles specific to ShiftSwapModal component
import { styled } from '@mui/system';
import { Box, Avatar as MuiAvatar, Typography, ListItem } from '@mui/material';

// Main content container
export const ShiftSwapModalContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',

  '& .MuiDivider-root': {
    margin: `${theme.spacing(1)} 0`,
  },

  '& .MuiList-root': {
    width: '100%',
    padding: 0,
    maxHeight: 300,
    overflow: 'auto',
    backgroundColor: theme.palette.background.secondary,
  },
}));

// Loading container
export const LoadingContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px 0',
});

// Large centered avatar
export const LargeAvatar = styled(MuiAvatar)(({ theme }) => ({
  width: 80,
  height: 80,
  margin: '0 auto',
  marginBottom: theme.spacing(2),
}));

// Shift details container
export const ShiftDetailsBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  marginBottom: theme.spacing(3),
}));

// Shift detail row
export const ShiftDetailRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px',
});

// Employee list item
export const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
  cursor: 'pointer',
  borderColor: theme.palette.divider,
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
  '&:active': {
    backgroundColor: theme.palette.action.selected,
  },
}));

// Employee list avatar
export const EmployeeAvatar = styled(MuiAvatar)({
  width: 48,
  height: 48,
});

// Employee name typography
export const EmployeeName = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 500,
  fontSize: '1rem',
}));

// Employee shift types typography
export const EmployeeShiftTypes = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  marginTop: theme.spacing(0.5),
}));

// Confirmation modal header
export const ConfirmationTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  textAlign: 'center',
}));

// Selected employee container
export const SelectedEmployeeBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '24px',
});

// Selected employee avatar
export const SelectedEmployeeAvatar = styled(MuiAvatar)({
  width: 56,
  height: 56,
  marginRight: '16px',
});

// Selected employee name
export const SelectedEmployeeName = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: '4px',
}));

// Confirmation message
export const ConfirmationMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  fontSize: '0.875rem',
  lineHeight: 1.5,
}));

// Action buttons container
export const ActionButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  flexDirection: 'column',
}));
